import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackVisit } from "@/lib/api";

// Registra una visita ad ogni cambio di pagina (analytics self-hosted).
export const Analytics = () => {
  const { pathname } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    trackVisit(pathname);
  }, [pathname]);
  return null;
};
